import { ScaleClient } from '../services/ohl.virtualCenter.api';
import moment from 'moment';

const apiScaleClient = new ScaleClient(process.env.REACT_APP_PUBLIC_API);

class ScalesProvider {

    getList = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;

        if (params.filter && params.filter.q) params.filter.id = params.filter.q;


        if (params.filter && params.filter.createdDate) {
            params.filter.createdDate = moment(params.filter.createdDate).format('yyyy-MM-DDTHH:mm:ss')
        }

        return apiScaleClient.list({
            pageNumber: page,
            pageSize: perPage,
            orderField: field,
            orderAsc: order === 'ASC',
            ...params.filter
        }).then((data) => {
            data.elements = data.elements.map(
                e => ({
                    ...e,
                })
            )
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }


    getScales = (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;

        return apiScaleClient.all({
            pageNumber: page,
            pageSize: perPage,
            orderField: field,
            orderAsc: order === 'ASC',
            ...params.filter
        }).then((data) => {
            data.elements = data.elements.map(
                e => ({
                    ...e,
                })
            )
            return {
                data: data.elements,
                total: data.total,
            }
        });
    }


    // obtiene un registro de escala por su id (id de registro)
    getOne = (resource, params) => {
        return apiScaleClient.scaleGet(params.id).then((data) => {

            let record = Array.isArray(data) ? (data[0] || null) : data;
            if (record === null || record === undefined) {
                return { data: { id: params.id, register: record } };
            }
            // Garantizar que tenga 'id'
            if (record.id === undefined && record.scaleRegisterId !== undefined) {
                record = { id: record.scaleRegisterId, ...record };
            }
            return { data: record };
        });
    }

    // Obtiene la definición de una escala por su id de escala (no el id de registro)
    getScaleDefinition = (resource, params) => {
        return apiScaleClient.scaleById(params.id).then((data) => ({ data }));
    }


    create = (resource, params) => {
        return apiScaleClient.scalePost(params.data).then((data) => ({
            data
        }));
    }

    delete = (resource, params) => {
        return apiScaleClient.scaleDelete(params.id).then(() => ({
            data: params.previousData
        }));
    }

    updatedResponse = (resource, params) => {
        return apiScaleClient.updatedResponse(params).then((data) => ({
            data
        }));
    }

    updatedScaleNotes = (resource, params) => {
        return apiScaleClient.updatedNote(params).then((data) => ({
            data
        }));
    }

   finishScaleRegister = (resource, params) => {
    // Función interna para limpiar la fecha al formato yyyy-MM-ddTHH:mm:ss
    const formatApiDate = (dateVal) => {
        if (!dateVal) return null;
        const d = new Date(dateVal);
        if (isNaN(d.getTime())) return null;
        
        // Extraemos las partes y forzamos el formato ISO local sin la Z final
        const pad = (num) => String(num).padStart(2, '0');
        
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    };

    const dto = {
        scaleRegisterId: params?.id ?? params?.scaleRegisterId,
        totalScore: params?.totalScore ? String(params.totalScore) : null,
        createdDate: formatApiDate(params?.createdDate) // <--- Aquí aplicamos el formato limpio
    };

    return apiScaleClient.finishScaleRegister(dto).then((data) => ({
        data
    }));

}
};

export default new ScalesProvider();
